import { clsx } from 'clsx';
import { PlainModal } from '@design-system/components/modal/modal';
import { fullSize } from '@design-system/components/modal/modal.css';
import { Typography } from '@design-system/components/typography/typography';
import { Button } from '@design-system/components/button/button';
import * as styles from './WhatsNewModal.css';

type WhatsNewModalProps = {
  isOpen: boolean;
  onClose: () => void;
  tag: string;
  title: string;
  description: string;
  imageSrc: string;
};

export const WhatsNewModal = ({
  isOpen,
  onClose,
  tag,
  title,
  description,
  imageSrc,
}: WhatsNewModalProps) => (
  <PlainModal
    isOpen={isOpen}
    onClose={onClose}
    modalClassName={clsx(fullSize, 'w-full md:w-[742px]')}
  >
    <div className={styles.content}>
      <div className={styles.textGroup}>
        <div className={styles.tag}>
          <Typography variant="body" size="medium" color="P-100">
            {tag}
          </Typography>
        </div>
        <Typography variant="headline" size="large">
          {title}
        </Typography>
        <Typography
          variant="body"
          size="large"
          fontWeight="normal"
          color="N-100"
        >
          {description}
        </Typography>
      </div>
      <img src={imageSrc} alt="" className={styles.image} />
      <Button color="neutral" onClick={onClose} className={styles.okButton}>
        Ok got it
      </Button>
    </div>
  </PlainModal>
);
